import { Button } from '@mui/material';
import { GitHubIcon } from '@natomalabs/natomui/src/icons';
import { useCallback } from 'react';
import useEnvironment from '../providers/Environment';

interface GitHubLoginButtonProps {
  redirectUrl?: string | null;
}

/**
 * A button that initiates GitHub OAuth authentication.
 * Constructs the OAuth URL with the current org slug and optional redirect URL.
 */
export default function GitHubLoginButton({
  redirectUrl
}: GitHubLoginButtonProps) {
  const { natoma } = useEnvironment();

  const handleGitHubLogin = useCallback(() => {
    const orgSlug = window.location.hostname
      .replace(`.${natoma.rootDomain}`, '')
      .replace(natoma.rootDomain, '');
    const params = new URLSearchParams();
    if (orgSlug) params.append('orgSlug', orgSlug);
    if (redirectUrl) params.append('redirectUrl', redirectUrl);
    const queryString = params.toString();
    window.location.href = `https://api.${natoma.rootDomain}/auth/github${queryString ? `?${queryString}` : ''}`;
  }, [natoma.rootDomain, redirectUrl]);

  return (
    <Button
      fullWidth
      variant="secondary"
      startIcon={<GitHubIcon />}
      onClick={handleGitHubLogin}
    >
      Continue with GitHub
    </Button>
  );
}
